
export const commentsEndpoints = {

    Delete : '/api/Comment/Delete',
    GetAll : '/api/Comment/GetAll',
    GetById : '/api/Comment/',
    Insert : '/api/Comment/Insert',
    Filter: '/api/Comment/Filter',
    Update : '/api/Comment/Update'

}